import { ICoreContext, ICultureInfoFormatter } from '@msdyn365-commerce/core';

// A zero fraction (",00" or ".00") followed only by non-digits, e.g. the " kr" suffix
const ZERO_FRACTION = /([.,])00(?=\D*$)/;

const patchedFormatters = new WeakSet<ICultureInfoFormatter>();

/**
 * Removes a zero fraction from a formatted price: "1 234,00 kr" -> "1 234 kr", "12,50 kr" untouched.
 */
export function stripZeroFraction(formattedPrice: string): string {
    return formattedPrice.replace(ZERO_FRACTION, '');
}

/**
 * Makes the request's shared currency formatter drop zero fractions. The formatter is one instance per
 * request that every module (standard and gh-*) formats prices through, so wrapping it once covers all.
 * Idempotent; call from render before any price is formatted.
 */
export function applyWholeNumberCurrencyFormat(context: ICoreContext | undefined): void {
    const formatter = context?.cultureFormatter;
    if (!formatter || typeof formatter.formatCurrency !== 'function' || patchedFormatters.has(formatter)) {
        return;
    }

    const formatCurrency = formatter.formatCurrency;
    formatter.formatCurrency = (price: string | number, currencyCode?: string): string =>
        stripZeroFraction(formatCurrency(price, currencyCode));
    patchedFormatters.add(formatter);
}
